export default __webpack_public_path__ + "static/media/arrow-right.2f8c1ba5.svg";